export function getWebsocketURI(customWebsocketUrl?: string): string {
	let WEBSOCKET_URI: string;

	if (customWebsocketUrl) {
		return customWebsocketUrl;
	}

	if (process.env.NODE_ENV !== 'production') {
		// In dev mode this allows the local dev proxy to use the WebSocket host
		// that matches the backend origin host. The __backendOriginHost is only
		// available with local dev server.
		const host = (window as any).__backendOriginHost || window.location.host;

		WEBSOCKET_URI = `wss://${host}`;
	} else {
		WEBSOCKET_URI = `wss://${window.location.host}`;
	}

	return WEBSOCKET_URI;
}
